<app-header></app-header>
<div class="section container-fluid pt-3 pb-4">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 sub-section pb-3">
            <div class="row">
                <div class="col-xl-8 main-feed">
                    <div class="d-flex flex-column my-3" *ngIf="!blogLoading && blog">
                        <span class="title">{{blog?.title}}</span>
                        <div class="horizontal-line mt-3"></div>
                        <div class="d-flex flex-row my-2">
                            <span class="blog-time mr-5">{{blog?.createdAt| date:'EEE dd MMM, yyyy'}}</span>
                            <span class="blog-time">Author: {{blog?.author?.name}}</span>
                        </div>
                        <div class="horizontal-line"></div>
                        <img *ngIf="!blog.image" class="blog-image" src="../../../assets/Images/blog-not-found.png">
                        <img *ngIf="blog.image" class="blog-image" [src]="blog.image">
                        <div class="content mt-3">
                            {{blog?.body}}
                        </div>
                    </div>
                    <div class="row my-5" *ngIf="blogLoading">
                        <div class="spinner-border loader" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 recent-feed">
                    <div class="d-flex flex-column">
                        <span class="sub-header mt-4 mb-2">Recent Posts</span>
                        <div class="row my-5" *ngIf="recentBlogLoading">
                            <div class="spinner-border loader" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row navigate my-1" *ngFor="let rblog of recentBlogs"
                            [routerLink]="['/blog-detail', rblog.postId]">
                            <img *ngIf="!rblog.image" src="../../../assets/Images/blog-not-found.png" class="blog-image"
                                alt="blog">
                            <img *ngIf="rblog.image" [src]="rblog.image" class="blog-image" alt="blog">
                            <div class="d-flex flex-column px-3">
                                <div class="blog-title-section mb-2 mt-1">
                                    <span class="title">{{rblog.title}}</span>
                                </div>
                                <div class="blog-sub-title-section">
                                    <span class="sub-title mt-2">{{rblog.body}}</span>
                                </div>
                            </div>
                        </div>
                        <span class="sub-header mt-3 mb-2">Tags</span>
                        <div class="row my-5" *ngIf="tagLoading">
                            <div class="spinner-border loader" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row flex-wrap">
                            <div class="tags" *ngFor="let tag of tags" [routerLink]="['/blog-listing']"
                                [queryParams]="{ tagId: tag.topicId}">
                                {{tag.name}} ({{tag.postCount}})</div>
                        </div>
                        <span class="sub-header mt-4 mb-2">Archives</span>
                        <div class="row my-5" *ngIf="monthLoading">
                            <div class="spinner-border loader" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row flex-wrap">
                            <div class="tags" *ngFor="let month of months" [routerLink]="['/blog-listing']"
                                [queryParams]="{ month: month.monthName}">
                                {{month.monthName}} ({{month.postCount}})</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>